import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Dispatch } from "redux";
import { ApplicationStore } from "src/store";
import DrawerToggleComponent from "./DrawerToggleComponent";
import { toggleGarageDrawer } from "src/store/actions/garageDrawer";

const mapStateToProps = ({ onlineShopper }: ApplicationStore) => {
    return {
        isCurrentlyOpen: onlineShopper.isDrawerOpen,
    };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
    return {
        toggleGPC: () => dispatch(toggleGarageDrawer()),
    };
};

const DrawerToggleContainer = withRouter(connect(mapStateToProps, mapDispatchToProps)(DrawerToggleComponent));

export default DrawerToggleContainer;
